import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import { MigrationError } from '../webApi/DataModels'
import { map } from 'lodash'

class MigrationErrorsState {
  public errors:MigrationError[] = []
}
const mutations = <MutationTree<MigrationErrorsState>>{
  setMigrationErrors (state: MigrationErrorsState, migrationErrors: MigrationError[]): void {
    state.errors = map(migrationErrors, (migrationError: MigrationError): MigrationError => {
      try {
        migrationError.Item = JSON.parse(migrationError.Item_JSON)
      } catch (error) {
        migrationError.Item = null
      }

      return migrationError
    })
  }
}
const actions = <ActionTree<MigrationErrorsState, any>>{
  loadMigrationErrors (store: ActionContext<MigrationErrorsState, any>): Promise<any> {
    return Promise.resolve('not needed')
    // return store.dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.MONITORING, permissionValue: constants.PERMISSION_VALUES.VIEW }, { root: true })
    //   .then((hasPermission):any => {
    //     if (!hasPermission) {
    //       return Promise.resolve('not needed')
    //     } else {
    //       return webApi.monitoring.get_Migration_Error_Logs().then((response: AxiosResponse) => {
    //         store.commit('setMigrationErrors', response.data)
    //         return Promise.resolve()
    //       }).catch((error) => {
    //         return Promise.reject(error)
    //       })
    //     }
    //   })
  }
}
const getters = <GetterTree<MigrationErrorsState, any>>{

}
export default ({
  namespaced: true,
  state: new MigrationErrorsState(),
  mutations,
  actions,
  getters
})
